import useGroupMemberships from "../../../../hooks/useGroupMemberships";

/*
    Create a custom locate widget with override functionality to
    go to the user's location when the custom button is clicked and
    trigger the iAudit functionality.
*/
const useAuditLocate = () => {
  const groupMemberships = useGroupMemberships();

  const addAuditLocate = ({ Locate, view, featureLayers, Graphic }) => {
    var locate = new Locate({
      view: view,
      useHeadingEnabled: false,
      goToOverride: function (view, options) {
        options.target.scale = 1200;
        return view.goTo(options.target);
      },
    });

    document
      .getElementById("auditButton")
      .addEventListener("click", function () {
        locate
          .locate()
          .then(function (event) {
            if (!event?.coords?.latitude || !event?.coords?.longitude) {
              return;
            }
            let longitude = event?.coords?.longitude;
            let latitude = event.coords.latitude;
            let point = {
              type: "point", // autocasts as new Point()
              longitude: longitude,
              latitude: latitude,
            };

            // Fires after the user's location has been found
            let actions = [];
            // Add action button for auditing contractors.
            if (
              groupMemberships.isPrimary ||
              groupMemberships.isAuditorContractor ||
              groupMemberships.isAuditPrimary
            ) {
              actions.push({
                title: "Contractor Audit",
                id: "contractorAudit",
                className: "esri-icon-edit",
              });
            }

            // Add action button for splicer audits.
            if (
              groupMemberships.isPrimary ||
              groupMemberships.isAuditorSplicer ||
              groupMemberships.isAuditPrimary
            ) {
              actions.push({
                title: "Splicing Audit",
                id: "splicerAudit",
                className: "esri-icon-edit",
              });
            }

            const pointGraphic = new Graphic({
              geometry: point,
              symbol: {
                type: "simple-marker",
                color: [7, 176, 19],
                outline: {
                  color: [104, 112, 121],
                  width: 1,
                },
              },
              popupTemplate: {
                title: "Perform Audit",
                actions: actions,
              },
            });
            featureLayers.graphicsLayer.add(pointGraphic);
            view.popup.open({
              features: [pointGraphic],
              location: pointGraphic.geometry,
            });
          })
          .catch(function (e) {
            // TODO
            console.log(e);
          });
      });
  };

  return addAuditLocate;
};

export default useAuditLocate;
